import React, { useRef } from "react";
import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import {
  getErrorMessageByKey,
  useNotification,
  useObject,
  useList,
  Select,
  Modal,
} from "@vokymlak/kabinet-ui";

function ModalCategoryInGroup(props) {
  const {
    object: [object],
  } = useObject({
    apiUrl: "/api/nomenclature/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackError: () => {
      props.handleClose();
    },
  });

  const {
    list: [list],
  } = useList({ apiUrl: "/api/nomenclature-categories/list", rootUrl: ROOT_URL });

  const selectNomenclatureCategoryId = useRef(null);

  const { notification } = useNotification();

  const changeEdit = (event) => {
    event.preventDefault();

    const nomenclatureCategoryId = selectNomenclatureCategoryId.current.value;

    const jsonData = {
      nomenclature_category_id:
        nomenclatureCategoryId.length > 0
          ? nomenclatureCategoryId === "null"
            ? null
            : Number(nomenclatureCategoryId)
          : null,
    };

    axios
      .put("/api/nomenclature/" + props.object.uuid + "/in-category", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Данные сохранены", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const getSelectOptions = (list) => {
    const options = [
      {
        value: "null",
        title: "Без категории",
      },
    ];

    list.map((item) => {
      if (item.nomenclature_category_type.tag === "CATEGORY") {
        const option = {
          value: item.id,
          title: item.title,
        };

        options.push(option);
      }
    });

    return options;
  };

  return (
    !!object &&
    !!list && (
      <Modal handleClose={() => props.handleClose()}>
          <form className="Form" onSubmit={(event) => changeEdit(event)}>
            <div className="Form__title">
              {object.name}
              <div className="Text__signature">Перенести в категорию</div>
            </div>

            <div className="Form__field Form__field_last">
              <Select
                reference={selectNomenclatureCategoryId}
                isFixed={true}
                options={!!list ? getSelectOptions(list) : getSelectOptions([])}
                label="Группа категорий"
                value={(!!object.nomenclature_category_id && object.nomenclature_category_id) || "null"}
              />
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_blue">
                Перенести
              </button>
            </div>
          </form>
      </Modal>
    )
  );
}

export default ModalCategoryInGroup;
